import React, { useState, FC, FormEvent } from "react"
import { connect } from "react-redux"
import UIkit from "uikit"
import { createTrack } from "../../store/actions/songs"
import { RootState } from "../../store/reducers"
import { Track } from "../../models/track"

interface StateProps {
  tags: string[]
  username: string
}

interface StateActions {
  createTrack: Function
}

const CreateTrack: FC<StateProps & StateActions> = ({
  tags,
  createTrack,
  username,
}) => {
  const t: Track = {
    title: "",
    featured: [],
    tag: "",

    imgFile: undefined,
    audFile: undefined,
    covername: "",
    id: "",
    likes: [],
    plays: [],
    src: "",
    uid: "",
    username: "",
  }
  const [track, setTrack] = useState<Track>(t)

  const audioTypes = [
    "mp3",
    "mpeg",
    "wav",
    "m4a",
    "flac",
    "aiff",
    "wma",
    "ogg",
    "webm",
    "oga",
    "mogg",
    "m4b",
    "m4p",
    "aac",
  ]

  const imageTypes = ["png", "jpg", "jpeg"]

  const onChange = (e: FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    console.log(e.currentTarget.value)
    setTrack({
      ...track,
      [e.currentTarget.id]: e.currentTarget.value,
    })
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    const { title, tag, audFile, covername } = track
    if (!tag) {
      track.tag = "custom"
    }
    if (!title) {
      UIkit.modal.dialog('<p class="uk-modal-body">A title is required</p>')
    } else if (!audFile) {
      UIkit.modal.dialog('<p class="uk-modal-body">Please select a file</p>')
    } else if (!covername) {
      UIkit.modal.dialog(
        '<p class="uk-modal-body">Please select cover image</p>'
      )
    } else {
      createTrack(track, username)
      setTrack(t)
    }
  }
  return (
    <div
      id="create-track"
      className="uk-width-2-3@s uk-width-1-2@m uk-width-1-1"
      style={{ margin: "70px auto 90px" }}
    >
      <h4 style={{ margin: "0 8px 12px" }}>Create track</h4>
      <div style={{ margin: "0 8px" }}>
        <form
          onSubmit={onSubmit}
          style={{ margin: "auto" }}
          className="  uk-padding-small uk-border-rounded bg-dark"
        >
          <fieldset className="uk-fieldset">
            <div className="uk-margin">
              <label className="uk-form-label">Title:</label>
              <input
                className="uk-input"
                id="title"
                type="text"
                onChange={onChange}
                placeholder="Title"
              />
            </div>

            <div className="uk-margin">
              <label className="uk-form-label">Genre:</label>
              <select onChange={onChange} id="tag" className="uk-select">
                {tags && tags.map((tag, i) => <option key={i}>{tag}</option>)}
              </select>
            </div>

            <div className="uk-margin">
              <label className="uk-form-label">
                Featured artists (<small>separate by comma</small>)
              </label>
              <textarea
                onChange={(e) => {
                  let featured = e.target.value.split(",")
                  setTrack({
                    ...track,
                    featured,
                  })
                }}
                className="uk-textarea"
                rows={3}
                placeholder="wizkid, nasty c, nyashinski"
              ></textarea>
              <div className="uk-margin-top">
                <label className="uk-form-label">
                  Audio: {track.src && <span>{track.src}</span>}{" "}
                </label>
                <div className="js-upload uk-placeholder uk-text-center">
                  <span className="uk-text-middle">Drag and drop or </span>
                  <div data-uk-form-custom>
                    <span className="">
                      <i className="material-icons-outlined md-18">
                        cloud_upload
                      </i>
                      Select audio file
                    </span>
                    <input
                      type="file"
                      id="aud"
                      onChange={(e) => {
                        const files = e.target.files ? e.target.files : []
                        const aud = files[0]
                        //   console.log(file.type.slice(file.type.length - 3))
                        if (
                          !audioTypes.includes(
                            aud?.type.split("/")[aud.type.split("/").length - 1]
                          )
                        ) {
                          UIkit.modal.dialog(
                            '<p class="uk-modal-body">Invalid format type</p>'
                          )
                        } else {
                          setTrack({
                            ...track,
                            audFile: aud,
                            src: aud?.name,
                          })
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="uk-margin-top">
                <label className="uk-form-label">
                  Cover image:{" "}
                  {track.covername && <span>{track.covername}</span>}
                </label>
                <div className="js-upload uk-placeholder uk-text-center">
                  <span className="uk-text-middle">Drag and drop or </span>
                  <div data-uk-form-custom>
                    <span className="">
                      <i className="material-icons-outlined">cloud_upload</i>
                      Select cover
                    </span>
                    <input
                      type="file"
                      id="cover"
                      onChange={(e) => {
                        const files = e.target.files ? e.target.files : []
                        const cover = files[0]
                        //   console.log(file.type.slice(file.type.length - 3))
                        if (
                          !imageTypes.includes(
                            cover?.type.split("/")[
                              cover.type.split("/").length - 1
                            ]
                          )
                        ) {
                          UIkit.modal.dialog(
                            '<p class="uk-modal-body">Invalid format type</p>'
                          )
                        } else {
                          setTrack({
                            ...track,
                            imgFile: cover,
                            covername: cover?.name,
                          })
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <input
                type="submit"
                className="uk-button uk-margin-small-top uk-border-rounded"
                value="Create"
              />
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  tags: state.data.tags,
  username: state.auth.user.username,
})

const mapDispatchToProps: StateActions = {
  createTrack,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTrack)
